import { Component, Inject } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';

export interface DocumentWorkingCopyToastData {
  documentName: string;
}

@Component({
  selector: 'app-document-working-copy-toast',
  templateUrl: './document-working-copy-toast.component.html',
  styleUrls: ['./document-working-copy-toast.component.scss'],
  standalone: false,
})
export class DocumentWorkingCopyToastComponent {
  readonly escapedDocumentName: string;

  constructor(
    private snackBarRef: MatSnackBarRef<DocumentWorkingCopyToastComponent>,
    @Inject(MAT_SNACK_BAR_DATA) data: DocumentWorkingCopyToastData
  ) {
    this.escapedDocumentName = this.escapeHtml(data.documentName);
  }

  openDocument(): void {
    this.snackBarRef.dismissWithAction();
  }

  dismiss(): void {
    this.snackBarRef.dismiss();
  }

  private escapeHtml(value: string): string {
    return value
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }
}
